import script from "./ClaimEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClaimEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./ClaimEditModal.vue?vue&type=style&index=0&id=4e6e26ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e6e26ea"]])

export default __exports__